// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2yqvF","option":"styles_option__334eM","selected":"styles_selected__2v7lf"};